module.exports = __webpack_public_path__ + "img/polygon.b14bdbdb.svg";